export const isExistingUser = (
  user: UserWithPermission | PendingUserWithPermission,
): user is UserWithPermission => {
  return Object.prototype.hasOwnProperty.call(user, 'userID')
}

export const isPendingUser = (
  user: UserWithPermission | PendingUserWithPermission,
): user is PendingUserWithPermission => {
  return Object.prototype.hasOwnProperty.call(user, 'sentTime')
}
